import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import AboutBanner3 from '../../widgets/AbountBanner3';


class SavlaHomePage extends Component {

   
    render() {

        return (
            <div>

                 <div id="content" className="site-content">
                <div className="content-wrapper">
                <Container>
                    <AboutBanner3 />
                </Container>
                    </div>
                    </div>

            </div>
        )
    }
}

export default SavlaHomePage;